import React from "react";
import { Section, Reveal, Eyebrow, Icon } from "../components/primitives.jsx";
import { IconTile, CTABand } from "../components/blocks.jsx";
import { PageHero, HeroArt } from "../components/visuals.jsx";

export function Careers({ go, c, radius = 16 }) {
  const t = c.careersPage;
  return (
    <main style={{ fontFamily: "var(--font-sans)" }}>
      <PageHero eyebrow={t.eyebrow} title={t.title} lede={t.lede} radius={radius} art={<HeroArt kind="careers" radius={radius} />} />

      <Section tone="wash">
        <Reveal><Eyebrow>{t.perksTitle}</Eyebrow></Reveal>
        <div className="rw-svc-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "var(--space-5)", marginTop: "var(--space-5)" }}>
          {t.perks.map((p, i) => (
            <Reveal key={i} delay={i * 80}>
              <div style={{ background: "var(--surface-card)", borderRadius: radius, padding: "var(--space-5)", height: "100%", border: "1px solid var(--border-subtle)", boxShadow: "var(--shadow-sm)", display: "flex", flexDirection: "column", gap: 12 }}>
                <IconTile name={p.icon} tone={i % 2 === 0 ? "red" : "ink"} radius={Math.max(8, radius - 4)} />
                <h3 style={{ margin: 0, fontSize: "var(--text-md)", fontWeight: 700, letterSpacing: "-0.01em", color: "var(--brand-ink)" }}>{p.title}</h3>
                <p style={{ margin: 0, fontSize: "var(--text-sm)", lineHeight: 1.6, color: "var(--text-muted)" }}>{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section tone="page">
        <Reveal><Eyebrow>{t.openEyebrow}</Eyebrow></Reveal>
        <div style={{ marginTop: "var(--space-5)", display: "flex", flexDirection: "column", gap: 12 }}>
          {t.roles.map((r, i) => (
            <Reveal key={i} delay={i * 60}>
              <div
                onClick={() => go("contact")}
                role="button"
                tabIndex={0}
                aria-label={r.title}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go("contact"); } }}
                className="rw-role"
                style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "var(--space-4)", background: "var(--surface-card)", borderRadius: radius, padding: "var(--space-5) var(--space-6)", border: "1px solid var(--border-subtle)", boxShadow: "var(--shadow-xs)", cursor: "pointer", transition: "transform var(--duration-base) var(--ease-out), box-shadow var(--duration-base) var(--ease-out)" }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateX(4px)"; e.currentTarget.style.boxShadow = "var(--shadow-sm)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateX(0)"; e.currentTarget.style.boxShadow = "var(--shadow-xs)"; }}
              >
                <div style={{ minWidth: 260, flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: "var(--text-lg)", fontWeight: 700, letterSpacing: "-0.01em", color: "var(--brand-ink)" }}>{r.title}</h3>
                  <span style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)" }}>{r.type}</span>
                </div>
                <span style={{ fontSize: "var(--text-2xs)", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--text-muted)", background: "var(--neutral-50)", padding: "6px 12px", borderRadius: "var(--radius-pill)" }}>{r.team}</span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: "var(--text-sm)", fontWeight: 700, color: "var(--brand-red)" }}>{t.apply} <Icon name="arrow-right" size={15} /></span>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <CTABand title={t.ctaTitle} lede={t.ctaLede} button={t.ctaButton} onClick={() => go("contact")} radius={radius} />
    </main>
  );
}
